import { parse as parseCookies } from 'cookie';

import { createApp } from './app';
// eslint-disable-next-line import/extensions
import { removeCssHotReloaded } from './collect-css-ssr.js';

removeCssHotReloaded();

const cookies = parseCookies(document.cookie);

const {
  app, router, vuexStore, piniaStore,
} = createApp({
  cookies,
  ostinApiUrl: process.env.API_URL,
});

if (typeof __INITIAL_STATE__ === 'object') {
  vuexStore.replaceState(window.__INITIAL_STATE__);
}

if (typeof __PINIA_INITIAL_STATE__ === 'object') {
  piniaStore.state.value = window.__PINIA_INITIAL_STATE__;
}

router.isReady().then(() => {
  app.mount('#root', true);
});
